var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuickFind = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M8.36 2.5a5.86 5.86 0 0 1 4.817 9.196c.331.016.658.15.911.403l3.014 3.014c.54.54.54 1.418 0 1.958l-.03.03c-.542.541-1.418.541-1.959 0l-3.014-3.013a1.38 1.38 0 0 1-.404-.911A5.86 5.86 0 1 1 8.36 2.5m0 1.406a4.453 4.453 0 1 0 0 8.907 4.453 4.453 0 0 0 0-8.907",
  clipRule: "evenodd"
})));
export default SvgQuickFind;